module.exports = __webpack_public_path__ + "static/media/ADS-email-logo.cc3eee78.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/PDFReport/ADS-email-logo.png
// module id = 3020
// module chunks = 0